// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../tools/HBuilderX/plugins/uniapp-cli/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tw-circle-back[data-v-75a1254b]{width:%?64?%;height:%?64?%;line-height:%?64?%;text-align:center;background:#fff;border-radius:100%;-webkit-transform:rotate(90deg);transform:rotate(90deg);box-shadow:4px -2px 12px -2px rgba(51,65,84,.1716)}", ""]);
// Exports
module.exports = exports;
